import $axios from '~/plugins/axios';

import { Admin, Api, GetAdminParams } from '~/api';
import { buildModule } from '../utils';
import { Dict, createDict } from '~/helpers';

const api = $axios as Api;

type LazyLoadingParams = Omit<GetAdminParams, 'limit' | 'offset'>;

export default buildModule()
	.withState({
		adminById: {} as Dict<Admin>,
		orderedIds: [] as number[],
		params: {} as LazyLoadingParams,
	})
	.withGetters({
		items: (state) => state.orderedIds.map(id => state.adminById[id]),
		byId: (state) => (id: number) => state.adminById[id] ?? null,
	})
	.withMutations({
		RESET (state, params: LazyLoadingParams = {}) {
			state.params = params;
			state.orderedIds = [];
		},
		APPEND_ADMINS (state, admins: Admin[]) {
			state.adminById = { ...state.adminById, ...createDict(admins, ({ id }) => id) };
			state.orderedIds = Array.from(new Set([ ...state.orderedIds, ...admins.map((admin) => admin.id) ]));
		},
		SET_ADMINS (state, admins: Admin[]) {
			state.adminById = { ...state.adminById, ...createDict(admins, ({ id }) => id) };
		},
	})
	.withActions({
		async getMore ({ state, commit }, limit: number | null = 20) {
			const params: GetAdminParams = { ...state.params, limit, offset: state.orderedIds.length };

			const { data } = await api.get('/admin', { params });

			commit('APPEND_ADMINS', data.payload);
		},
		async prefetchAdmins ({ commit }, adminIds: number[]) {
			const params: GetAdminParams = { adminId: adminIds };
			const { data } = await api.get('/admin', { params });

			commit('SET_ADMINS', data.payload);
		},
		resetParams ({ state, commit }, params: LazyLoadingParams = {}) {
			commit('RESET', { ...state.params, ...params });
		},
	});

